import React, { Fragment, useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Card, CardBody, Col, Row, Container } from 'reactstrap';
import ReactRouterPropTypes from 'react-router-prop-types';
import { reset } from 'redux-form';
import { format } from 'date-fns';
import GraphQL from '../../GraphQL';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../redux/actions/loadingActions';
import {
  menuListByFilterQuery,
  removeMenuMutation,
} from '../../shared/queries/Menu';
import columns from './Components/Columns';
import Modal from '../../shared/components/Modal';
import PrintMenuModal from './Components/PrintMenuModal';
import MatTable from '../../shared/components/material-table';
import { generateReport, openReport } from '../../shared/utils/smartutils';
import { REPORT_PARAMETERS, REPORT_TYPES } from '../../shared/utils/constants';

const Menu = ({ t, dispatch, history }) => {
  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [printMenuModal, setPrintMenuModal] = useState(false);
  const [selectedDto, setSelectedDto] = useState({});

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const loadData = () => {
    showLoading();
    const filter = {
      id: 0,
      active: false,
      inDetail: false,
      studentQuantity: 0,
      deleted: false,
      filterByStatus: false,
      updaterId: 0,
    };
    const query = menuListByFilterQuery(filter);
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        const menuListByFilter = res.menuListByFilter.map((item) => ({
          ...item,
          activeDescription: t(`general.yesno.${item.active}`),
        }));
        setData(menuListByFilter);
      })
      .catch((error) => {
        hideLoading();
        console.error(error);
      });
  };

  const addItemClickHandler = () => {
    history.push('/minime/cardapio/mnt/0');
  };

  const editItemClickHandler = (evt, rowData) => {
    history.push(`/minime/cardapio/mnt/${rowData.id}`);
  };

  const togglePrintMenuModal = () => {
    dispatch(reset('PrintMenuModal'));
    setPrintMenuModal(!printMenuModal);
  };

  const printDetailMenu = async (dtIni, dtFim, id) => {
    togglePrintMenuModal();
    const formData = new FormData();

    formData.append(REPORT_PARAMETERS.REPORTTYPE, REPORT_TYPES.RELA_CARDAP);
    formData.append(
      REPORT_PARAMETERS.pDATAINIC,
      format(new Date(dtIni), 'yyyy-MM-dd')
    );
    formData.append(
      REPORT_PARAMETERS.pDATAFINA,
      format(new Date(dtFim), 'yyyy-MM-dd')
    );
    formData.append(REPORT_PARAMETERS.pCO00CARD, id);

    showLoading();
    generateReport(formData)
      .then(async (res) => {
        openReport(res.data);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('report.error-generate')
        );
      });
  };

  const printItemClickHandler = (evt, rowData) => {
    setSelectedDto({ ...rowData });
    if (!rowData.inDetail) {
      window.open(rowData.fileUrl);
    } else {
      togglePrintMenuModal();
    }
  };

  const removeItemClickHandler = (evt, rowData) => {
    setSelectedDto({ ...rowData });
    toggleModal();
  };

  const deleteItem = () => {
    toggleModal();
    showLoading();
    const removeQuery = removeMenuMutation(selectedDto.id);
    GraphQL(removeQuery, {})
      .then(() => {
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-removed')
        );
        loadData();
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-remove')
        );
      });
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <Fragment>
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={t('notifications.delete_cardapio_modal')}
        toggle={toggleModal}
        modal={modal}
        onConfirm={deleteItem}
      />
      {printMenuModal && (
        <PrintMenuModal
          title={t('screens.mnt_cardapio.printMenuParameters')}
          modal={printMenuModal}
          toggle={togglePrintMenuModal}
          menuId={selectedDto.id}
          menuTitle={selectedDto.name}
          printDetailMenu={printDetailMenu}
        />
      )}
      <Container>
        <Row className="Table">
          <Col md={12} lg={12}>
            <Card>
              <CardBody className="material-table-card">
                <div className="material-table__wrap">
                  <MatTable
                    data={data}
                    pageSize={20}
                    columns={columns(t)}
                    onRefreshClick={loadData}
                    deleteAction={toggleModal}
                    title={t('panels.cardapio')}
                    onAddClick={addItemClickHandler}
                    onEditClick={editItemClickHandler}
                    onPrintClick={printItemClickHandler}
                    onRemoveClick={removeItemClickHandler}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

Menu.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(Menu)
);
